<template>
  <div class="left-col-block blocks">
    <header class="header">
      <div class="content text-center">
      <div class="title">
        <h1>Hi, I'm Nuño Valencia</h1>

      </div>
        <h2>Looking for expert guidance in digital transformation? Let's connect!</h2>
      <hr />
      
        <p class="lead">AI / Cloud Solution Architect</p>
        <p class="lead">I design and build the systems: GenAI, RAG, Cloud and Kubernetes.</p>
        <p class="lead">Banking, insurance, IoT, industrial, media and eCommerce.</p>
        <p class="lead">With extensive experience in software development, from the early days of programming, since the days of <img src="https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/msdos/msdos-original.svg" width="25" height="25" /></p>
        
        <ul class="social-icon">
          <li><a href="https://www.facebook.com/nunovalencia"><i class="fab fa-facebook" aria-hidden="true"></i></a></li>
          <li><a href="https://twitter.com/elegant_maker"><i class="fab fa-twitter" aria-hidden="true"></i></a></li>
          <li><a href="https://www.linkedin.com/in/nunovalencia"><i class="fab fa-linkedin" aria-hidden="true"></i></a></li>
          <li><a href="https://github.com/Drouiz"><i class="fab fa-github" aria-hidden="true"></i></a></li>
          <li><a href="https://www.youtube.com/channel/UC8TkeB050lh8G1G7iMCaOkg"><i class="fab fa-youtube" aria-hidden="true"></i></a></li>
          <li><a href="https://www.instagram.com/elegant_maker/"><i class="fab fa-instagram" aria-hidden="true"></i></a></li>
          <li><a href="#"><i class="fab fa-slack" aria-hidden="true"></i></a></li>
          <li><a href="https://dribbble.com/drouiz"><i class="fab fa-dribbble" aria-hidden="true"></i></a></li>
        </ul>
      </div>
      <div class="text-center"><PrintButton /></div>
      <div class="profile-img"></div>
    </header>
    <!-- .header-->
  </div>
</template>
<script>
import PrintButton from './components/print-button'
export default {
  components: { PrintButton }
}
</script>
<style scoped>
h2 {
  color: white;
}

.white {
  color: white;
}




</style>
